const SECOND = 1000;
const MINUTE = SECOND * 60;

export const ScribeConfig = {
  SERVICE: 'trident',
  REGISTERED_NAME: 'comms',
  IDLE_TIMEOUT: MINUTE * 5,
};

const helper = {
  templateEvent: (event) => `${ScribeConfig.SERVICE}.campaign.${event}`,
  fullTemplateEvent: (event) =>
    `${ScribeConfig.REGISTERED_NAME}.${ScribeConfig.SERVICE}.campaign.${event}`,
};

const ScribeEventName = {
  NAVIGATION: `${ScribeConfig.SERVICE}.navigation`,
  FORM_OPEN: helper.templateEvent('open'),
  CAMPAIGN_CREATED: helper.templateEvent('created'),
  CAMPAIGN_EDITED: helper.templateEvent('edited'),
  CAMPAIGN_REQUESTED: helper.templateEvent('requested'),
  CAMPAIGN_APPROVED: helper.templateEvent('approved'),
  CAMPAIGN_REJECTED: helper.templateEvent('rejected'),
  CAMPAIGN_ACTIVATED: helper.templateEvent('activated'),
  CAMPAIGN_DEACTIVATED: helper.templateEvent('deactivated'),
  CAMPAIGN_WITHDRAWN: helper.templateEvent('withdrawn'),
  CAMPAIGN_METRICS: helper.templateEvent('metrics'),
  SEGMENT_COUNTRY_CHECK_BLOCKED: helper.templateEvent(
    'segmentCountryCheckBlocked',
  ),
  PROJECT_METRICS: helper.templateEvent('project-metrics'),
  GENERATED_CONTENT: helper.fullTemplateEvent('generatedContent'),
};

export const ScribeExtras = {
  LEAVE_PAGE: {
    type: 'leave_page',
  },
  CLOSE_PAGE: {
    type: 'close_page',
  },
  OPEN_PAGE: {
    type: 'open_page',
  },
  DOWNLOAD_REPORT: {
    type: 'download-report',
  },
  IDLE_TIMEOUT: {
    type: 'idle',
  },
};

export default ScribeEventName;
